import Typography from '../../../atoms/typography'
import { Grid } from '@mui/material'
import { styled } from '@mui/system'

const Root = styled(Grid)`
	margin-bottom: ${({ theme }) => theme.spacing(3)};
	justify-content: flex-start;
	gap: ${({ theme }) => theme.spacing(2)};
	${({ theme }) => theme.breakpoints.up('sm')} {
		gap: ${({ theme }) => theme.spacing(3)};
	}
`

const Anchor = styled(Typography)`
	cursor: pointer;
	:hover {
		text-decoration: underline;
	}
	${({ theme }) => theme.breakpoints.up('sm')} {
		margin-top: 0;
	}
`

export { Root, Anchor }
